import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization/userSlice'

export const useGetExternalProductFriendlyName = () => {
  const { externalProduct } = useSelector(selectCurrentUser)

  if (externalProduct.toLowerCase().includes('pestpac')) return 'PestPac'

  // catch all
  return 'Host System'
}
